// AUTO-GENERATED — DO NOT EDIT
// Source: vendor-registry.json (per VENDOR-REGISTRY-DOCTRINE-1)
// Run `npm run codegen:vendor-registry` to regenerate.

/* eslint-disable */

import { createSyntraAdapterFactory } from './syntra/SyntraAdapter.js';
import { createMockAdapterFactory } from './mock/MockVendorAdapter.js';
import { createSamsaraAdapterFactory } from './samsara/SamsaraAdapter.js';
import { createTiveAdapterFactory } from './tive/TiveAdapter.js';
import { createORBCOMMAdapterFactory } from './orbcomm/ORBCOMMAdapter.js';
import { createJimiAdapterFactory } from './jimi/JimiAdapter.js';
import { createM2MDAdapterFactory } from './m2md/M2MDAdapter.js';
import { createMinewAdapterFactory } from './minew/MinewAdapter.js';
import { createWiliotAdapterFactory } from './wiliot/WiliotAdapter.js';
import { createEnoceanAdapterFactory } from './enocean/EnoceanAdapter.js';
import { createPragmaticAdapterFactory } from './pragmatic/PragmaticAdapter.js';
import { createMotiveAdapterFactory } from './motive/MotiveAdapter.js';
import { createGeotabAdapterFactory } from './geotab/GeotabAdapter.js';
import { createRoambeeAdapterFactory } from './roambee/RoambeeAdapter.js';
import { createControlantAdapterFactory } from './controlant/ControlantAdapter.js';
import { createSensaTruthAdapterFactory } from './sensatruth/SensaTruthAdapter.js';
import { createGenericMqttAdapterFactory } from './generic_mqtt/GenericMqttAdapter.js';
import { createGenericLorawanAdapterFactory } from './generic_lorawan/GenericLorawanAdapter.js';
import { createGenericCellularAdapterFactory } from './generic_cellular/GenericCellularAdapter.js';
import { createVizionAisAdapterFactory } from './vizion_ais/VizionAisAdapter.js';
import { createMarineTrafficAisAdapterFactory } from './marine_traffic_ais/MarineTrafficAisAdapter.js';

export const VENDOR_ADAPTER_FACTORIES = {
  'syntra': createSyntraAdapterFactory,
  'mock': createMockAdapterFactory,
  'samsara': createSamsaraAdapterFactory,
  'tive': createTiveAdapterFactory,
  'orbcomm': createORBCOMMAdapterFactory,
  'jimi': createJimiAdapterFactory,
  'm2md': createM2MDAdapterFactory,
  'minew': createMinewAdapterFactory,
  'wiliot': createWiliotAdapterFactory,
  'enocean': createEnoceanAdapterFactory,
  'pragmatic': createPragmaticAdapterFactory,
  'motive': createMotiveAdapterFactory,
  'geotab': createGeotabAdapterFactory,
  'roambee': createRoambeeAdapterFactory,
  'controlant': createControlantAdapterFactory,
  'sensatruth': createSensaTruthAdapterFactory,
  'generic_mqtt': createGenericMqttAdapterFactory,
  'generic_lorawan': createGenericLorawanAdapterFactory,
  'generic_cellular': createGenericCellularAdapterFactory,
  'vizion_ais': createVizionAisAdapterFactory,
  'marine_traffic_ais': createMarineTrafficAisAdapterFactory,
};

export const VENDOR_OPERATIONAL_STATUS = {
  'syntra': 'WIRED',
  'mock': 'WIRED',
  'samsara': 'STUB',
  'tive': 'TYPE_ONLY',
  'orbcomm': 'TYPE_ONLY',
  'jimi': 'STUB',
  'm2md': 'STUB',
  'minew': 'STUB',
  'wiliot': 'ASPIRATIONAL',
  'enocean': 'ASPIRATIONAL',
  'pragmatic': 'ASPIRATIONAL',
  'motive': 'TYPE_ONLY',
  'geotab': 'TYPE_ONLY',
  'roambee': 'TYPE_ONLY',
  'controlant': 'TYPE_ONLY',
  'sensatruth': 'TYPE_ONLY',
  'generic_mqtt': 'TYPE_ONLY',
  'generic_lorawan': 'TYPE_ONLY',
  'generic_cellular': 'TYPE_ONLY',
  'vizion_ais': 'TYPE_ONLY',
  'marine_traffic_ais': 'TYPE_ONLY',
};
